 type SortTicketFieldName =
 'NUMBER_TICKET' |
 'LAST_UPDATE' |
 'STATION_NAME' |
 'TYPE_PANNE' |
 'STATE';
const SortTicketFieldName = (() => {
  const NUMBER_TICKET: SortTicketFieldName = 'NUMBER_TICKET';
  const LAST_UPDATE: SortTicketFieldName = 'LAST_UPDATE';
  const STATION_NAME: SortTicketFieldName = 'STATION_NAME';
  const TYPE_PANNE: SortTicketFieldName = 'TYPE_PANNE';
  const STATE: SortTicketFieldName = 'STATE';
  function values(): SortTicketFieldName[] {
    return [
     NUMBER_TICKET,
     LAST_UPDATE,
     STATION_NAME,
     TYPE_PANNE,
     STATE
    ];
  }
  return { NUMBER_TICKET, LAST_UPDATE, STATION_NAME, TYPE_PANNE, STATE, values };
})();

export { SortTicketFieldName };
